exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.img-download[data-v-1653b05e]{left:50%;position:relative;margin-left:-35px}.fancybox-inner[data-v-1653b05e]{overflow:hidden!important}.fancybox-nav[data-v-1653b05e]{width:40px!important}.thumbnail-img-file[data-v-1653b05e]{width:auto;height:50px;padding:10px 25px 10px 10px}.thumbnail-img-file .thumbnail-img-delete[data-v-1653b05e]{right:0;bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1653b05e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/edit/ReportEdit.vue
// module id = 642
// module chunks = 1